import CompanyAnalytics from './CompanyAnalytics';

export default CompanyAnalytics;
